<script setup lang="ts">
import {reactive, ref} from "vue";
import {CourseService} from "@/api/api.ts";
import MultiImageUploader from "components/common/MultiImageUploader.vue";
import {ElNotification} from "element-plus";

const multiImageUploader = ref<InstanceType<typeof MultiImageUploader>>();
const isShowing = ref(false)

const initData = {
  course_id: 0,
  notice_id: 0,
  title: "",
  content: "",
  images: ""
}

const form = reactive({...initData})

const show = async (_course_id: number, _notice_id: number) => {
  isShowing.value = true
  form.course_id = _course_id
  try {
    form.notice_id = _notice_id
    if (form.notice_id) {
      // 获取信息
      const res = await CourseService.getNoticeInfo({
        notice_id: form.notice_id
      })
      if (res.data.code === 200 && res.data.data) {
        form.title = res.data.data.title
        form.content = res.data.data.content
        multiImageUploader.value?.init(res.data.data.images)
      }
    }
  } catch (err) {
    console.warn(err)
  }
}

const emit = defineEmits(["onSubmitSuccess"])

const onSubmit = async () => {
  if (!multiImageUploader.value?.checkAllUploadSuccess()) {
    return ElNotification.warning({
      title: "注意",
      message: "请等待所有图片上传成功"
    })
  }
  try {
    const res = await CourseService.addSaveNotice({
      course_id: form.course_id,
      notice_id: form.notice_id,
      title: form.title,
      content: form.content,
      images: multiImageUploader.value?.getImageUrls() || "",
    })
    if (res.data.code === 200) {
      ElNotification.success({
        title: "成功",
        message: res.data.msg
      })
      emit("onSubmitSuccess")
      hide()
    } else {
      ElNotification.error({
        title: "请求失败,请查看控制台",
        message: res.data.msg
      })
    }
  } catch (e) {
    console.warn(e)
  }
}

const hide = () => {
  isShowing.value = false
}

const onClose = () => {
  Object.assign(form, initData)
  multiImageUploader.value?.init([])
}

defineExpose({
  show, hide
})
</script>

<template>
  <el-dialog title="" v-model="isShowing" align-center width="50rem" :show-close="false" @close="onClose">
    <el-input class="my-border text-20px!" type="text" v-model="form.title" placeholder="请输入标题" maxlength="30" show-word-limit/>
    <el-input class="my-border mt-2rem" type="textarea" v-model="form.content" placeholder="请输入公告正文" show-word-limit maxlength="500" :autosize="{ minRows: 6, maxRows: 10 }"/>
    <div class="mt-2rem">
      <multi-image-uploader :max="3" ref="multiImageUploader"/>
    </div>
    <div class="mt-4rem">
      <el-button type="primary" @click="onSubmit">
        <template v-if="form.notice_id">
          保存修改
        </template>
        <template v-else>
          发布
        </template>
      </el-button>
      <el-button type="primary" plain @click="hide">取消</el-button>
    </div>
  </el-dialog>
</template>

<style scoped>
.my-border {
  --el-border-color: transparent;
  --el-input-focus-border-color: transparent;
  --el-input-hover-border-color: transparent;
  --el-input-clear-hover-color: transparent;
  box-shadow: none !important;
}

.my-border:hover {
  box-shadow: none !important;
}
</style>

<style scoped>

</style>
